import { render, staticRenderFns } from "./PrivacyAgreementInfo.vue?vue&type=template&id=4eba84e2&"
import script from "./PrivacyAgreementInfo.vue?vue&type=script&lang=js&"
export * from "./PrivacyAgreementInfo.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyAgreementInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports